/**
 * 自动化 / 爬虫 UA（无头浏览器、CI 脚本、搜索引擎爬虫）。
 * UA 端类型监控会排除这些，避免测试/抓取流量污染真实设备统计。
 */
export const AUTOMATION_UA_REG =
  /headlesschrome|headless|puppeteer|playwright|phantomjs|selenium|webdriver|python-requests|curl\/|wget\/|spider|crawler|slurp|googlebot|bingbot|baiduspider|yandexbot|duckduckbot|facebookexternalhit|bot\//i;

export const DEVICE_REG = {
  RC: /^.*(rm500|dji rc).*$/i,
  BAIDU_APP: /baiduboxapp/i,
  TABLET: /iPad|Tablet|Macintosh/i,
  // Android 手机兜底：部分机型（如 PLK110）会被 ua-parser 误判为 LG 平板，UA 同时含 Android + Mobile 即视为手机（平板 UA 通常不含 Mobile）
  ANDROID_MOBILE: /android.*mobile|mobile.*android/i,
  MOBILE:
    /((Mobile)|(MIDP)|(WAP)|(UP\.Browser)|(Smartphone)|(Obigo)|(AU\.Browser)|(wxd\.Mms)|(WxdB\.Browser)|(CLDC)|(UP\.Link)|(KM\.Browser)|(UCWEB)|(SEMC\-Browser)|(Mini)|(Symbian)|(Palm)|(Nokia)|(Panasonic)|(MOT)|(SonyEricsson)|(NEC)|(Alcatel)|(Ericsson)|(BENQ)|(BenQ)|(Amoisonic)|(Amoi)|(Capitel)|(PHILIPS)|(SAMSUNG)|(Lenovo)|(Mitsu)|(Motorola)|(SHARP)|(WAPPER)|(LG)|(EG900)|(CECT)|(Compal)|(kejian)|(Bird)|(BIRD)|(G900\/V1\.0)|(Arima)|(CTL)|(TDG)|(Daxian)|(DAXIAN)|(DBTEL)|(Eastcom)|(EASTCOM)|(PANTECH)|(Dopod)|(Haier)|(HAIER)|(KONKA)|(KEJIAN)|(LENOVO)|(Soutec)|(SOUTEC)|(SAGEM)|(SEC)|(SED)|(EMOL)|(INNO55)|(ZTE)|(iPhone)|(Android)|(Windows CE)|(Wget)|(Java)|(curl)|(Opera))/i,
} as const;

/**
 * OS 判定统一口径（R-7）
 *
 * middleware/纯模块与 _document 必须引用同源常量，避免同 UA 在不同位置得出不同 os_type。
 * Harmony 判定必须先于 Android（HarmonyOS UA 同时含 Android 关键字），由调用方保证优先级。
 */
export const OS_APPLE = /macintosh|mac os x|iphone|ipad|ipod/i;
export const OS_WINDOWS = /windows nt/i;
export const OS_HARMONY = /harmonyos/i;
export const OS_ANDROID = /android/i;

/**
 * iOS 设备族(iPhone/iPad/iPod)统一口径(M4)
 *
 * 仅用于 OS 判定(`getOsType` → 'iOS'),与 `OS_APPLE` 区分:后者含 macintosh(桌面 macOS)。
 */
export const IOS_DEVICE_REG = /iphone|ipad|ipod/i;

/**
 * iPhone 类手机(iPhone/iPod)统一口径(M4)
 *
 * 用于「期望端 = m」真值判定。**不含 ipad**:iPad 属平板,ua-parser 判为 tablet →
 * `getJudgeTerminal` 返回 'pc';若期望端把 iPad 判成 m 会与判定端不一致,产生假异常。
 * 故此处与 iOS 设备族(IOS_DEVICE_REG)刻意区分,保持与判定端口径自洽。
 */
export const IPHONE_PHONE_REG = /iphone|ipod/i;

